import { HOST_TYPE } from '@utils/api-helper/host';
import { careersTypes } from '../constants';

export const getJobDetails = () => ({
  type: careersTypes.GET_JOB_DETAILS,
  endpoint: `${process.env.WORKABLE_WRAPPER_URL}gamma/spi/v3/jobs?limit=100&state=published&include_fields=employment_type`,
  method: 'get'
});

export const getCMSData = () => ({
  type: careersTypes.GET_CMS_DATA,
  endpoint: 'api/policies/careers',
  method: 'get',
  hostType: HOST_TYPE.CMS
});
